// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   staffs: [],
//   filteredStaffs: [],
//   displayedStaffs: [],
//   initialStaffData: {
//     name: '',
//     phone: '',
//     address: '',
//     mail: '',
//     department: '',
//     salary: '',
//     userType: '',
//     emergencyDetails: { contactNo: '', name: '' },
//     workingHrs: { start: '', end: '' },
//     dateOfJoining: '',
//     dob: '',
//     incentive: 0,
//     incentiveType: '',
//     incentivePeriod: '', 
//     target: 0,
//     gender: '',
//   },
//   filters: {
//     search: '',
//     genderBy: '',
//   },
//   pagination: {
//     currentPage: 1,
//     itemsPerPage: 10,
//     totalItems: 0,
//     totalPages: 1,
//   },
//   loading: false,
//   error: null,
// };

// const staffSlice = createSlice({
//   name: 'staffs',
//   initialState,
//   reducers: {
//     setLoading: (state, action) => {
//       state.loading = action.payload;
//     },
//     setError: (state, action) => {
//       state.error = action.payload;
//     },
//     setAllStaffs: (state, action) => {
//       state.staffs = action.payload;
//       applyFilters(state);
//     },
//     updateStaffData: (state, action) => {
//       state.initialStaffData = {
//         ...state.initialStaffData,
//         ...action.payload,
//       };
//     },
//     resetStaffData: (state) => {
//       state.initialStaffData = initialState.initialStaffData;
//     },
//     setFilters: (state, action) => {
//       state.filters = {
//         ...state.filters,
//         ...action.payload,
//       };
//       applyFilters(state);
//     },
//     setCurrentPage: (state, action) => {
//       state.pagination.currentPage = action.payload;
//       paginate(state);
//     },
//     setPagination: (state, action) => {
//       state.pagination = {
//         ...state.pagination,
//         ...action.payload,
//       };
//       state.pagination.totalPages = Math.ceil(
//         state.pagination.totalItems / state.pagination.itemsPerPage,
//       );
//       paginate(state);
//     },
//     resetFilters: (state) => {
//       state.filters = initialState.filters;
//       state.pagination.itemsPerPage = 10;
//       applyFilters(state);
//     },
//   },
// });

// function applyFilters(state) {
//   const { search, genderBy } = state.filters;
//   let result = [...state.staffs];

//   if (genderBy && genderBy !== 'Both') {
//     result = result.filter((item) => item.gender === genderBy);
//   }

//   if (search) {
//     const searchLower = search.toLowerCase();
//     result = result.filter(
//       (item) =>
//         item.name?.toLowerCase().includes(searchLower) ||
//         item.mail?.toLowerCase().includes(searchLower) ||
//         item.phone.toString().includes(search),
//     );
//   }
//     state.pagination.currentPage = 1;
//   state.filteredStaffs = result;
//   state.pagination.totalItems = result.length;
//   state.pagination.totalPages = Math.ceil(result.length / state.pagination.itemsPerPage);
//   paginate(state);
// }

// function paginate(state) {
//   const { currentPage, itemsPerPage } = state.pagination;
//   const start = (currentPage - 1) * itemsPerPage;
//   const end = start + itemsPerPage;
//   state.displayedStaffs = state.filteredStaffs.slice(start, end);
// }

// export const {
//   setLoading,
//   setError,
//   setAllStaffs,
//   updateStaffData,
//   resetStaffData,
//   setFilters,
//   setCurrentPage,
//   setPagination,
//   resetFilters,
// } = staffSlice.actions;

// export default staffSlice.reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  staffs: [],
  filteredStaffs: [],
  displayedStaffs: [],
  initialStaffData: {
    name: '',
    phone: '',
    address: '',
    mail: '',
    department: '',
    salary: '',
    userType: '',
    emergencyDetails: { contactNo: '', name: '' },
    workingHrs: { start: '', end: '' },
    dateOfJoining: '',
    dob: '',
    incentive: 0,
    incentiveType: '',
    incentivePeriod: '', 
    target: 0,
    gender: '',
  },
  filters: {
    search: '',
    gender: [], // Changed from genderBy to gender array for BigFilter compatibility
  },
  pagination: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 1,
  },
  loading: false,
  error: null,
};

const staffSlice = createSlice({
  name: 'staffs',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAllStaffs: (state, action) => {
      state.staffs = action.payload;
      applyFilters(state);
    },
    updateStaffData: (state, action) => {
      state.initialStaffData = {
        ...state.initialStaffData,
        ...action.payload,
      };
    },
    resetStaffData: (state) => {
      state.initialStaffData = initialState.initialStaffData;
    },
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
      applyFilters(state);
    },
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
      paginate(state);
    },
    setPagination: (state, action) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
      state.pagination.totalPages = Math.ceil(
        state.pagination.totalItems / state.pagination.itemsPerPage,
      );
      paginate(state);
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.pagination.currentPage = 1; // Reset to page 1
      state.pagination.itemsPerPage = 10;
      applyFilters(state);
    },
  },
});

function applyFilters(state) {
  const { search, gender } = state.filters;
  let result = [...state.staffs];

  // Gender filter (now supports multiple selection)
  if (gender.length > 0) {
    result = result.filter((item) => gender.includes(item.gender));
  }

  // Search filter — fuzzy subsequence match (same logic as productSlice)
 const cleanSearch = (search || '').trim();

  if (cleanSearch) {
      const lowerSearch = cleanSearch.toLowerCase().replace(/[\s\-()]/g, '');

    const fuzzyMatch = (text) => {
    const lowerText = text?.toLowerCase().replace(/[\s\-()]/g, '');
      if (!lowerText) return false;

      let textIndex = 0;
      let searchIndex = 0;
      while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
        if (lowerText[textIndex] === lowerSearch[searchIndex]) {
          searchIndex++;
        }
        textIndex++;
      }
      return searchIndex === lowerSearch.length;
    };

    result = result.filter(
      (item) =>
        fuzzyMatch(item?.name) ||
        fuzzyMatch(item?.mail) ||
        fuzzyMatch(item?.phone?.toString()),
    );
  }

  state.filteredStaffs = result;
  state.pagination.totalItems = result.length;
  state.pagination.totalPages = Math.ceil(result.length / state.pagination.itemsPerPage) || 1;

  // Ensure current page is valid
  if (state.pagination.currentPage > state.pagination.totalPages && state.pagination.totalPages > 0) {
    state.pagination.currentPage = 1;
  }

  paginate(state);
}

function paginate(state) {
  const { currentPage, itemsPerPage } = state.pagination;
  const start = (currentPage - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  state.displayedStaffs = state.filteredStaffs.slice(start, end);
}

export const {
  setLoading,
  setError,
  setAllStaffs,
  updateStaffData,
  resetStaffData,
  setFilters,
  setCurrentPage,
  setPagination,
  resetFilters,
} = staffSlice.actions;

export default staffSlice.reducer;
